import React from 'react';
import AdminContentPage from 'core/views/admin/AdminContentPage';

const AdminContent = () => <AdminContentPage />;

export default AdminContent;
